import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import DatePicker from 'react-datepicker';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import '../styles/Analytics.css';

const styles = theme => ({
  datePickerContainer: {
    display: 'flex',
    justifyContent: 'space-evenly',
    alignItems: 'center',
  },
  calendar: {
    zIndex: 999,
  },
  dateFilter: {
    height: '30px',
    padding: '10px 5px',
    fontFamily: 'Helvetica, sans-serif',
    fontWeight: '300',
    fontSize: '16px',
    border: '1px solid #aaa',
    borderRadius: '4px',
    margin: '5px 10px 5px 10px',
  },
  paper: {
    color: theme.palette.text.secondary,
    marginBottom: 24,
    display: 'flex',
    flexDirection: 'column',
    padding: 15,
  },
  element_title: {
    fontSize: 18,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  element1_value: {
    color: '#FF3B00',
    fontSize: 40,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  element2_value: {
    color: '#FF8900',
    fontSize: 40,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  element3_value: {
    color: '#00BC2B',
    fontSize: 40,
    textAlign: 'center',
    fontWeight: 'bold',
  },
});

class SharedHeaderAnalytics extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      userProfileDialog: true,
      userData: null,
    };
  }

  render() {
    const {
      classes,
      title,
      element1_title,
      element1_value,
      element2_title,
      element2_value,
      element3_title,
      element3_value,
      campaignFilter,
      setCampaignFilter,
    } = this.props;

    return (
      <React.Fragment>
        <Paper className={classes.paper} elevation={0}>
          <Grid container>
            <Grid item xs={12}>
              <Typography
                className={classes.subtitle}
                variant="subtitle1"
                gutterBottom
              >
                {title}
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <div className={classes.datePickerContainer}>
                Start date:
                <DatePicker
                  popperClassName={classes.calendar}
                  className={classes.dateFilter}
                  placeholderText="Click to select a date"
                  selected={this.props.dateFrom}
                  onChange={date => this.props.setDateFrom(date)}
                  onBlur={() => this.props.refreshData()}
                  showTimeSelect
                  timeFormat="HH:mm"
                  timeIntervals={15}
                  timeCaption="time"
                  dateFormat="MMMM d, yyyy h:mm aa"
                  disabledKeyboardNavigation
                />
              </div>
              <div className={classes.datePickerContainer}>
                End date:
                <DatePicker
                  popperClassName={classes.calendar}
                  className={classes.dateFilter}
                  placeholderText="Click to select a date"
                  selected={this.props.dateTo}
                  onChange={date => this.props.setDateTo(date)}
                  onBlur={() => this.props.refreshData()}
                  showTimeSelect
                  timeFormat="HH:mm"
                  timeIntervals={15}
                  timeCaption="time"
                  dateFormat="MMMM d, yyyy h:mm aa"
                  disabledKeyboardNavigation
                />
              </div>
            </Grid>

            {campaignFilter ? (
              <Grid item xs={3}>
                <div className={classes.element_title}>
                  {'Select Campaign:'}
                </div>
                <div>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={campaignFilter === 'all' ? true : false}
                        onChange={() => {
                          setCampaignFilter('all');
                          this.props.refreshData();
                        }}
                      />
                    }
                    label="All"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={campaignFilter === 'points' ? true : false}
                        onChange={() => {
                          setCampaignFilter('points');
                          this.props.refreshData();
                        }}
                      />
                    }
                    label="Points"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={campaignFilter === 'day1' ? true : false}
                        onChange={() => {
                          setCampaignFilter('day1');
                          this.props.refreshData();
                        }}
                      />
                    }
                    label="Day 1"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={campaignFilter === 'day2' ? true : false}
                        onChange={() => {
                          setCampaignFilter('day2');
                          this.props.refreshData();
                        }}
                      />
                    }
                    label="Day 2"
                  />
                </div>
              </Grid>
            ) : (
              ''
            )}
            <Grid item xs={3}>
              <div className={classes.element1_value}>{element1_value}</div>
              <div className={classes.element_title}>{element1_title}</div>
            </Grid>
            <Grid item xs={3}>
              <div className={classes.element2_value}>{element2_value}</div>
              <div className={classes.element_title}>{element2_title}</div>
            </Grid>
            <Grid item xs={3}>
              <div className={classes.element3_value}>{element3_value}</div>
              <div className={classes.element_title}>{element3_title}</div>
            </Grid>
          </Grid>
        </Paper>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(SharedHeaderAnalytics);
